<template>
    <div>订单</div>
</template>

<script>
export default {
    name:"OrderIndex"
}
</script>

<style >

</style>